import { createContext, useContext } from 'react';

import { User } from './CheckerRouter.utils';

export type CheckerContext = {
  acf: any;
  apiError: Error | null;
  experimentDecisions?: Record<string, unknown>;
  user: Pick<User, 'dpSellerId' | 'email'> | null;
};

const initialState = {
  acf: [],
  apiError: null,
  experimentDecisios: {},
  user: null,
};

type CheckerProviderProps = {
  children: React.ReactNode;
  value: CheckerContext;
}

const CheckerContext = createContext<CheckerContext>(initialState);

export const CheckerProvider = ({ children, value }: CheckerProviderProps) => (
  <CheckerContext.Provider
    value={value}
  >
    {children}
  </CheckerContext.Provider>
);

export const useCheckerContext: () => CheckerContext = () => useContext(CheckerContext);
